/* eslint-disable */
import { useEffect, useState } from 'react';
import Inspection from '../../models/inspection.entity';
import Payment from '../../models/payment-credit-card.entity';
import PaymentSuccess from '../../models/payment-sucess.entity';
import inputMaskService from '../../services/input-mask.service';
import storageService from '../../services/storage.service';
import PaymentHeader from './components/PaymentHeader/index';
import TicketModal from './components/TicketModal/index';
import {
  ActionRow,
  BackBtn,
  Container,
  Error,
  ErrorRow,
  Form,
  FormRow,
  InputLabel,
  InputText,
  InputWrapper,
  Option,
  OptionIcon,
  OptionsWrapper,
  PriceRow,
  SubmitBtn,
  Price,
  PriceLabel,
} from './Payment.styles'
import paymentService from './services/payment.service';
import { SpinnerWhite } from '../../styles/Generic.styles';
import { useHistory } from 'react-router';
import WhatsAppButton from '../Home/components/WhatsAppButton';
import couponService from '../Summary/components/DiscountCoupon/services/coupon.service';
import { CircularProgress } from '@mui/material';
import PaymentCreditCard from '../../models/payment-credit-card.entity';
import { LocalStoreKeysEnum } from '../../models/enums/localstore-keys.enum';

const PaymentComponent = () => {
  const history = useHistory();
  const [transaction, setTransaction] = useState(new Inspection());
  const [payment, setState] = useState<Payment>(new Payment());
  const [paymentOption, setPaymentOption] = useState('credit');
  const [validityDate, setValidityDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  const originalPrice = localStorage.getItem(LocalStoreKeysEnum.LABEL_INSPECTION_PRICE);

  const [price, setPrice] = useState(() => {
    return parseFloat(originalPrice || "64.90");
  });
  const [loadingPrice, setLoadingPrice] = useState(true);

  const [showAddressForm, setshowAddressForm] = useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setState((prevState: any) => ({
      ...prevState,
      [name]: inputMaskService.getMaskedValue(name, value)
    }));
  };

  const goBack = () => {
    history.goBack();
  };

  const onSelectPaymentOption = (option: string) => {
    setPaymentOption(option);
    localStorage.setItem('payment-type', option);
  }

  const handleValidation = () => {
    let formIsValid = true;
    const formErrors: string[] = [];

    if (!payment.name) {
      formIsValid = false;
      formErrors.push('O campo Nome do Cartão é obrigatório');
    }

    if (!payment.cardNumber) {
      formIsValid = false;
      formErrors.push('O campo Número do Cartão é obrigatório');
    }

    if (!payment.cvv) {
      formIsValid = false;
      formErrors.push('O campo CVV é obrigatório');
    }

    if (!validityDate) {
      formIsValid = false;
      formErrors.push('O campo Valido até é obrigatório');
    }

    setErrors(formErrors);
    return formIsValid;
  };

  const setDefaultError = () => {
    setErrors(['Ocorreu um erro ao processar o pagamento. Tente Novamente']);
  }

  const sendPayment = () => {
    setLoading(true);

    if (!handleValidation()) {
      setLoading(false);
      return;
    }

    const couponCode = localStorage.getItem('coupon');
    if (couponCode) {
      payment.couponCode = couponCode;
    }

    payment.userTransactionId = transaction.transactionId;
    payment.unitValue = Number(price);
    paymentService.sendCreditCard(payment)
      .then((result) => {
        const { data } = result.data;
        const success = new PaymentSuccess(data);

        storageService.setObject('payment-sucess', success);
        history.push('success');
      })
      .catch((error) => {
        const requestErrors: string[] = [];
        if (!error) {
          setDefaultError();
          return;
        }

        const errorKeys = Object.keys(error);
        if (!errorKeys.length) {
          setDefaultError();
          return;
        }

        errorKeys.forEach((key) => {
          requestErrors.push(error[key][0]);
        });
        setErrors(requestErrors);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangeValidityDate = (e: any) => {
    const { value } = e.target;
    setValidityDate(inputMaskService.getMaskedValue('date', value));

    if (value.length === 5) {
      const validityValues = value.split('/');

      setState((prevState: any) => ({
        ...prevState,
        ['expirationMonth']: validityValues[0],
        ['expirationYear']: validityValues[1]
      }));
    }
  };

  const selectTicket = () => {
    setshowAddressForm(true);
  };

  /* istanbul ignore next */
  const cancelModal = () => {
    setshowAddressForm(false);
    onSelectPaymentOption('credit');
  }

  const checkCoupon = () => {
    const couponCode = localStorage.getItem('coupon');

    if (!couponCode) {
      setLoadingPrice(false);
      return;
    }

    couponService.validate(couponCode)
      .then((result) => {
        const { data } = result;
        setPrice(data.amount);
      })
      .finally(() => { setLoadingPrice(false); });
  }

  useEffect(() => {
    const inspection = storageService.getObject('inspection');
    setTransaction(inspection);
    checkCoupon();
    setErrors([]);
  }, []);

  return (
    <Container>
      <PaymentHeader />
      <OptionsWrapper>
        <Option
          className={paymentOption === 'credit' ? 'selected' : ''}
          active={paymentOption === 'credit'}
          onClick={() => { onSelectPaymentOption('credit'); setshowAddressForm(false); }}
        >
          <OptionIcon src={`images/payments/${paymentOption === 'credit' ? 'card-selected.svg' : 'card.svg'}`} />
          Cartão de Crédito
        </Option>
        <Option
          className={paymentOption === 'ticket' ? 'selected' : ''}
          active={paymentOption === 'ticket'}
          onClick={() => { onSelectPaymentOption('ticket'); selectTicket(); }}
        >
          <OptionIcon src="images/payments/barcode.png" />
          Boleto
        </Option>
        <Option
          className={paymentOption === 'pix' ? 'selected' : ''}
          active={paymentOption === 'pix'}
          onClick={() => { onSelectPaymentOption('pix'); selectTicket(); }}
        >
          <OptionIcon src="images/payments/pix.svg" />
          Pix
        </Option>
      </OptionsWrapper>
      {!showAddressForm && (
        <Form>
          <InputWrapper>
            <InputLabel>Nome do Cartão</InputLabel>
            <InputText
              type="text"
              onChange={handleChange}
              name="name"
              value={payment.name}
              placeholder="Nome como consta no cartão"
              data-testid="input-card-name"
            />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>Número do Cartão</InputLabel>
            <InputText
              type="text"
              onChange={handleChange}
              name="cardNumber"
              maxLength="19"
              value={payment.cardNumber}
              placeholder="____ ____ ____ ____"
              data-testid="input-card-number"
            />
          </InputWrapper>
          <FormRow>
            <InputWrapper>
              <InputLabel>Valido até</InputLabel>
              <InputText
                type="text"
                maxLength="5"
                onChange={onChangeValidityDate}
                value={validityDate}
                placeholder="mm/aa"
                data-testid="input-card-expiration"
              />
            </InputWrapper>
            <InputWrapper>
              <InputLabel>CVV</InputLabel>
              <InputText
                type="text"
                maxLength="3"
                onChange={handleChange}
                name="cvv"
                value={payment.cvv}
                placeholder="___"
                data-testid="input-card-cvv"
              />
            </InputWrapper>
          </FormRow>
          <PriceRow>
            {!loadingPrice && (
              <>
                <PriceLabel>Valor Total</PriceLabel> <Price>R${price.toFixed(2).replace('.', ',')}</Price>
              </>
            )}
            {loadingPrice && (
              <CircularProgress sx={{ color: '#D40020' }} size={30} />
            )}
          </PriceRow>
          {(errors.length > 0) && (
            <ErrorRow>
              {errors && errors.map((error: string, index) => (
                <Error key={index}>{error}</Error>
              ))}
            </ErrorRow>
          )}
          <ActionRow>
            <SubmitBtn
              type="button"
              disabled={loading}
              onClick={() => { sendPayment(); }}
              data-testid="finish-btn"
            >
              {!loading && (
                <>Finalizar Compra</>
              )}
              {loading && (
                <SpinnerWhite />
              )}
            </SubmitBtn>
            <BackBtn
              disabled={loading}
              onClick={() => { goBack(); }}
              data-testid="cancel-btn"
            >
              Voltar
            </BackBtn>
          </ActionRow>
        </Form>
      )}
      {showAddressForm && (
        <TicketModal price={price} />
      )}
      <WhatsAppButton />
    </Container>
  );
};

export default PaymentComponent;
